import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';

import { OfflineBookingAllList, OfflineBookingListOnlineDetailsOrOffline } from '../Models/OfflineBookingProperties';
import { OfflineBookingList } from '../Models/OfflineBookingProperties';
import { OfflineRequestTypes } from '../Models/ActiveClasses';
import { OfflineRequestService } from '../Services/offline-request.service';
import { NgForm } from '@angular/forms';
import { Component, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { OfflineToOnlineProperties, TicketDataRequest, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';

import * as $ from 'jquery';
import { ViewChild } from '@angular/core';
import { DxDataGridComponent, DxLoadPanelModule, DxDataGridModule } from 'devextreme-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule } from 'devextreme-angular/ui/nested';
@Component({
    selector: 'app-offline-request',
    templateUrl: './offline-request.component.html',
    styleUrls: ['./offline-request.component.css'],
    imports: [NavMenuComponent, DxLoadPanelModule, DxDataGridModule, DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule]
})
/** OfflineRequest component*/
export class OfflineRequestComponent {
  /** OfflineRequest ctor */


  tktPnrRight = new TicketPnrRights();
  requestTypeList$: Observable<OfflineRequestTypes[]>;
  //requestList: OfflineBookingList[];
  requestList: OfflineBookingAllList[];
  objectRequest = new OfflineBookingAllList();
  offlineOrOnlineRequestList = new OfflineBookingListOnlineDetailsOrOffline();
  requestListForConverting: OfflineBookingAllList[];
  collapsed = false;
  userId: number = 0;
  agencyId: string = "";
  bookingID: number;
  requestTypeId: number = 0;
  ticketReqFromOnline: string;
  voidReqFromOnline: string;
  pnrReqFromOnline: string;
  isLoadPanelVisible: boolean = false;
  requestData: any;
  constructor(private NewSuccess: NgbModal, private service: OfflineRequestService, private router: Router, private ticketIssuanceService: TicketIssuanceService) {
    this.onClickEditRequest = this.onClickEditRequest.bind(this);

    //this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
  }
  @ViewChild('confirmationModal') confirmationModal: ElementRef;
  @ViewChild("dataGridRequestList") gridRequest: DxDataGridComponent;
  ngOnInit() {

    try {
      this.isLoadPanelVisible = true;
      this.userId = Number(localStorage.getItem("UserId"));
      this.agencyId = localStorage.getItem("AgencyId");
      this.bookingID = Number(localStorage.getItem("OnlineBookingId"));
      this.loadrights();
      //23-jan-24 Comment this Function
      // this.loadDataOfOnlineRequest();
      //end
      this.loadBaseData();
      localStorage.removeItem("OnlineBookingId");
      this.requestTypeId = Number(localStorage.getItem("requestTypeId"));
      //this.OnRequestTypeChange(this.requestTypeId);
    } catch (ex) { console.log(ex); }
  }
  loadrights() {
    ////////////////////////////////////////
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;
    })
  }
  //23-jan-24 change this Function
  loadBaseData() {
    try {
      this.offlineOrOnlineRequestList.agencyId = this.agencyId;
      this.offlineOrOnlineRequestList.userId = this.userId;
      this.offlineOrOnlineRequestList.onlineBookingId = this.bookingID;
      this.offlineOrOnlineRequestList.isTicketOnline = localStorage.getItem("IsTicket");
      this.offlineOrOnlineRequestList.isVoidOnline = localStorage.getItem("IsVoid");
      this.offlineOrOnlineRequestList.isPnrCancelOnline = localStorage.getItem("IsPnr");
      this.offlineOrOnlineRequestList.isRefund = localStorage.getItem("IsRefund");
      this.offlineOrOnlineRequestList.ticketReRequest = Boolean(JSON.parse(localStorage.getItem("TicketReRequest")));
      this.service.getOfflineBookingAllData(this.offlineOrOnlineRequestList).subscribe((data) => {
        // console.log(data);
        if (data.length == 0) {
          this.isLoadPanelVisible = false;
        }
        localStorage.removeItem("OnlineBookingId");
        localStorage.removeItem("IsTicket");
        this.offlineOrOnlineRequestList.isTicketOnline = "";
        localStorage.removeItem("IsTicket");
        this.offlineOrOnlineRequestList.isVoidOnline = "";
        localStorage.removeItem("IsVoid");
        this.offlineOrOnlineRequestList.isPnrCancelOnline = "";
        localStorage.removeItem("IsPnr");
        this.offlineOrOnlineRequestList.isRefund = "";
        localStorage.removeItem("IsRefund");
        this.offlineOrOnlineRequestList.ticketReRequest = false;
        localStorage.removeItem("TicketReRequest");
        this.requestListForConverting = data;
        for (let i = 0; i < this.requestListForConverting.length; i++) {
          let bookingdashAgencyId = `${this.requestListForConverting[i].agencyId}-${this.requestListForConverting[i].offlineBookingId}`

          this.requestListForConverting[i].bookingAgencyId = bookingdashAgencyId;

          let travelDateFormat = this.requestListForConverting[i].travelDate;

          let dateDateLong: Date = new Date(travelDateFormat);
          let datePipe: DatePipe = new DatePipe('en-UK');
          this.requestListForConverting[i].travelDate = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));

          let bookingDateFormat = this.requestListForConverting[i].creationDate;

          let datebookDateLong: Date = new Date(bookingDateFormat);
          let datebookPipe: DatePipe = new DatePipe('en-UK');
          this.requestListForConverting[i].creationDate = (datebookPipe.transform(datebookDateLong, 'dd/MM/yyyy'));
        }
        if (this.requestListForConverting.length > 0) {

          this.requestList = this.requestListForConverting;

          this.isLoadPanelVisible = false;
        }


        // this.re = of(data);

      });
      this.service.getAirOfflineBookingBaseData().subscribe((data) => {
        //  console.log(data);

        this.requestTypeList$ = of(data.requestTypesList);

      });
    } catch (ex) { console.log(ex); }
  }

  //23-jan-24 Comment this Function

  // loadDataOfOnlineRequest() {

  //   this.offlineOrOnlineRequestList.agencyId = this.agencyId;
  //   this.offlineOrOnlineRequestList.userId = this.userId;
  //   this.offlineOrOnlineRequestList.onlineBookingId = this.bookingID;
  //   this.offlineOrOnlineRequestList.isTicketOnline = localStorage.getItem("IsTicket");
  //   this.offlineOrOnlineRequestList.isVoidOnline = localStorage.getItem("IsVoid");
  //   this.offlineOrOnlineRequestList.isPnrCancelOnline = localStorage.getItem("IsPnr");
  //   this.offlineOrOnlineRequestList.isRefund = localStorage.getItem("IsRefund");
  //   this.offlineOrOnlineRequestList.ticketReRequest = Boolean(JSON.parse(localStorage.getItem("TicketReRequest")));
  // /*  this.ticketIssuanceService.getBookingInfo*/
  //   //from ticket issue to offline
  //   //if (this.bookingID != 0 && this.ticketReqFromOnline == "True") {
  //   //  this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {

  //   //    this.objectRequest.creationDate = (data.bookingInfo.bookingDate).toString();
  //   //    this.objectRequest.pnr = data.bookingInfo.pnr;
  //   //    if (data.sectorInfo[0].toAirport != "" || data.sectorInfo[0].toAirport != undefined &&
  //   //      data.sectorInfo[0].toAirportName != "" || data.sectorInfo[0].toAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirport != "" || data.sectorInfo[0].fromAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirportName != "" || data.sectorInfo[0].fromAirportName != undefined) {


  //   //      var airport = `${data.sectorInfo[0].toAirport} - ${data.sectorInfo[0].toAirportName}/${data.sectorInfo[0].fromAirport} - ${data.sectorInfo[0].fromAirportName}`
  //   //      this.objectRequest.onlineBookingId = data.bookingInfo.bookingID;
  //   //      this.objectRequest.passName = data.bookingPassengerInfo[0].firstName;
  //   //      this.objectRequest.travelDate = (data.bookingPassengerInfo[0].travelingDate).toString();
  //   //      this.objectRequest.bookingSource = data.bookingPassengerInfo[0].supplierCode;
  //   //      this.objectRequest.tktNo = data.bookingPassengerInfo[0].ticketNo;
  //   //      this.objectRequest.sector = airport;
  //   //      this.objectRequest.agencyId = data.bookingInfo.finalBuyerID;
  //   //      this.objectRequest.status = "Requested";
  //   //      this.objectRequest.requestType = 7;
  //   //      this.objectRequest.creationUser = data.bookingInfo.creationUser;

  //   //    }
  //   //    //this.requestList.push(this.objectRequest);
  //   //    this.service.saveOnlineTktRequest(this.objectRequest).subscribe((data1) => {


  //   //        localStorage.removeItem("OnlineBookingId");
  //   //        localStorage.removeItem("IsTicket");
  //   //        this.ticketReqFromOnline = "";
  //   //      this.bookingID = 0;
  //   //      this.router.navigateByUrl('/offlineRequestList');
  //   //    })
  //   //    //console.log(data);
  //   //  })

  //   //}
  //   ////from void  to offline
  //   //else if (this.bookingID != 0 && this.voidReqFromOnline == "True") {
  //   //  this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {
  //   //    this.objectRequest.creationDate = (data.bookingInfo.bookingDate).toString();
  //   //    this.objectRequest.pnr = data.bookingInfo.pnr;
  //   //    if (data.sectorInfo[0].toAirport != "" || data.sectorInfo[0].toAirport != undefined &&
  //   //      data.sectorInfo[0].toAirportName != "" || data.sectorInfo[0].toAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirport != "" || data.sectorInfo[0].fromAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirportName != "" || data.sectorInfo[0].fromAirportName != undefined) {


  //   //      var airport = `${data.sectorInfo[0].toAirport} - ${data.sectorInfo[0].toAirportName}/${data.sectorInfo[0].fromAirport} - ${data.sectorInfo[0].fromAirportName}`
  //   //      this.objectRequest.onlineBookingId = data.bookingInfo.bookingID;
  //   //      this.objectRequest.passName = data.bookingPassengerInfo[0].firstName;
  //   //      this.objectRequest.travelDate = (data.bookingPassengerInfo[0].travelingDate).toString();
  //   //      this.objectRequest.bookingSource = data.bookingPassengerInfo[0].supplierCode;
  //   //      this.objectRequest.tktNo = data.bookingPassengerInfo[0].ticketNo;
  //   //      this.objectRequest.sector = airport;
  //   //      this.objectRequest.agencyId = data.bookingInfo.finalBuyerID;
  //   //      this.objectRequest.status = "Requested";
  //   //      this.objectRequest.requestType = 8;
  //   //      this.objectRequest.creationUser = data.bookingInfo.creationUser;

  //   //    }



  //   //    //this.requestList.push(this.objectRequest);
  //   //    this.service.saveOnlineTktRequest(this.objectRequest).subscribe((data) => {

  //   //        localStorage.removeItem("OnlineBookingId");
  //   //        localStorage.removeItem("IsVoid");
  //   //        this.voidReqFromOnline = "";
  //   //        this.bookingID = 0;
  //   //      this.router.navigateByUrl('/offlineRequestList');
  //   //    })
  //   //    //console.log(data);
  //   //  })

  //   //}
  //   //      //from pnr  to offline
  //   //else if (this.bookingID != 0 && this.pnrReqFromOnline == "True") {
  //   //  this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {

  //   //    this.objectRequest.creationDate = (data.bookingInfo.bookingDate).toString();
  //   //    this.objectRequest.pnr = data.bookingInfo.pnr;
  //   //    if (data.sectorInfo[0].toAirport != "" || data.sectorInfo[0].toAirport != undefined &&
  //   //      data.sectorInfo[0].toAirportName != "" || data.sectorInfo[0].toAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirport != "" || data.sectorInfo[0].fromAirportName != undefined &&
  //   //      data.sectorInfo[0].fromAirportName != "" || data.sectorInfo[0].fromAirportName != undefined) {


  //   //      var airport = `${data.sectorInfo[0].toAirport} - ${data.sectorInfo[0].toAirportName}/${data.sectorInfo[0].fromAirport} - ${data.sectorInfo[0].fromAirportName}`
  //   //      this.objectRequest.onlineBookingId = data.bookingInfo.bookingID;
  //   //      this.objectRequest.passName = data.bookingPassengerInfo[0].firstName;
  //   //      this.objectRequest.travelDate = (data.bookingPassengerInfo[0].travelingDate).toString();
  //   //      this.objectRequest.bookingSource = data.bookingPassengerInfo[0].supplierCode;
  //   //      this.objectRequest.tktNo = data.bookingPassengerInfo[0].ticketNo;
  //   //      this.objectRequest.sector = airport;
  //   //      this.objectRequest.agencyId = data.bookingInfo.finalBuyerID;
  //   //      this.objectRequest.status = "Requested";
  //   //      this.objectRequest.requestType = 12;
  //   //      this.objectRequest.creationUser = data.bookingInfo.creationUser;

  //   //    }
  //   //    //this.requestList.push(this.objectRequest);
  //   //    this.service.saveOnlineTktRequest(this.objectRequest).subscribe((data) => {

  //   //        localStorage.removeItem("OnlineBookingId");
  //   //        localStorage.removeItem("IsPnr");
  //   //        this.voidReqFromOnline = "";
  //   //        this.bookingID = 0;
  //   //      this.router.navigateByUrl('/offlineRequestList');
  //   //    })
  //   //    //console.log(data);
  //   //  })

  //   //}
  // }
  //OnRequestTypeChange(typeId) {
  //  this.requestList = [];
  //  if (typeId == 2) {


  //  }
  //  else if (typeId == 3) {
  //    this.service.getTicketRequestList(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //      }
  //    });
  //  }
  //  else if (typeId == 4) {
  //    this.service.getVoidRequestList(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //      }
  //    });
  //  }
  //  else if (typeId == 5) {
  //    this.service.getRefundRequestList(this.userId, this.agencyId).subscribe((data) => {
  //      this.requestList = data;
  //      for (let i = 0; i < this.requestList.length; i++) {
  //        this.requestList[i].date = this.requestList[i].date.split('T')[0];
  //      }
  //    });
  //  }
  //}

  //getRequestList() {
  //  try {

  //    this.userId = Number(localStorage.getItem('UserId'));
  //    this.agencyId = localStorage.getItem('AgencyId');
  //    this.service.CheckOfflineRequestAgaintAgencyAndUserId(this.agencyId, this.userId).subscribe((data) => {
  //      if (data) {
  //        this.service.getRequestList(this.userId, this.agencyId).subscribe((data2) => {

  //          this.requestList = (data2);
  //          console.log(data2);
  //        });
  //      }
  //    });

  //  } catch (ex) { console.log(ex); }
  //}
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  onCellPrepared(e) {
    if (e.rowType === "data" && e.column.dataField === "requestTypeName") {
      /* #7df481 */

      if (e.data.requestTypeName === "Offline Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Offline Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Offline Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online PNR Cancel Request") {
        e.cellElement.style.color = "blue";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Import PNR Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Offline Booking/Group Request") {
        e.cellElement.style.color = "purple";
        e.cellElement.style.fontWeight = "700";
      }
      // Tracks the `Amount` data field
      //e.watch(function () {
      //  return e.data.requestType;
      //}, function () {
      //  e.cellElement.style.color = e.data.requestType = "Offline Ticket Request" ? "green" : "red";
      //})
    }
  }

  OpenModel(confirmationModal) {
    this.NewSuccess.open(confirmationModal, {

      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'md',
    })
  }
  offlinetoOnline = new OfflineToOnlineProperties();
  onClickEditRequest(e, targetmodel) {
    this.requestData = e.row.data;

    // replace this condtion
    //if (e.row.data.requestTypeName == "Online Ticket Request") {
    //  if (this.tktPnrRight.issueTicket) {
    //    this.OpenModel(this.confirmationModal);
    //  }

    //}

    // replace this condtion
    if (e.row.data.requestTypeName == "Online Ticket Request") {
      if (this.tktPnrRight.issueTicket) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.TicketIssueReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.TicketIssueReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline))
        this.router.navigate(['/ticket-issuance']);
      }
    }
    else if (e.row.data.requestTypeName == "Online Void Request") {
      if (this.tktPnrRight.voidTicket) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.VoidReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.VoidReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
    }
    else if (e.row.data.requestTypeName == "Online PNR Cancel Request") {
      if (this.tktPnrRight.cancelPnr) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.PNRReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.PNRReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
    }
    else if (e.row.data.requestTypeName == "Online Refund Request") {
      if (this.tktPnrRight.refund) {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.RefundReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "True");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        localStorage.setItem("bookingID", e.row.data.onlineBookingId);
        this.offlinetoOnline.RequestTypeIdOffline = e.row.data.requestTypeName;
        this.offlinetoOnline.AgencyTicketReqFromOffline = e.row.data.agencyId;
        this.offlinetoOnline.RefundReqFromOffline = true;
        localStorage.setItem("OffilineRequest", "False");
        localStorage.setItem("fromroutePageNoright", "OfflinePage");
        this.offlinetoOnline.OfflineId = Number(e.row.data.offlineBookingId);
        localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
        this.router.navigateByUrl('/ticket-issuance');
      }
    }
    else if (e.row.data.requestTypeName == "Online Import PNR Ticket Request") {
      localStorage.setItem("importPNRID", e.row.data.onlineBookingId);
      localStorage.setItem("fromroutePageNoright", "OfflinePage");
      localStorage.setItem('isOfflineParked', "True");
      this.router.navigateByUrl('/importPNR');
    }
    //20-jan-24
    else if (e.row.data.requestTypeName.includes("Offline")) {
      localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
      localStorage.setItem('RequestActionOffline', 'User');
      localStorage.setItem('RequestTypeOffline', 'View');
      localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
      if (e.row.data.requestTypeName.includes("Offline Booking")) {
        this.router.navigateByUrl('/offlineBooking');
      }
      else if (e.row.data.requestTypeName == "Offline Ticket Request") {
        this.router.navigateByUrl('/offlineTicket');
      }
      else if (e.row.data.requestTypeName == "Offline Refund Request") {
        this.router.navigateByUrl('/offlineRefund');
      }
      else if (e.row.data.requestTypeName == "Offline Void Request") {
        this.router.navigateByUrl('/offlineVoid');
      }
      else if (e.row.data.requestTypeName == "Offline Reissue Request") {
        this.router.navigateByUrl('/offlineReissue');
      }

    }
    //else if (e.row.data.requestTypeName == "Offline Booking New Request") {
    //  localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    //  localStorage.setItem('RequestActionOffline', 'User');
    //  localStorage.setItem('RequestTypeOffline', 'View');
    //  localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
    //  this.router.navigateByUrl('/offlineChatNew');
    //}
    //else if (e.row.data.requestTypeName.includes("Offline Booking")) {
    //  localStorage.setItem("OfflineBookingRequestID", e.row.data.offlineBookingId);
    //  this.router.navigate(['offlineBookingRequestCreate']);

    //}
    ////end
    //else {
      
    //   if (e.row.data.requestTypeName == "Offline Ticket Request") {
    //    localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    //    localStorage.setItem('RequestActionOffline', 'User');
    //    localStorage.setItem('RequestTypeOffline', 'View');
    //    localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
    //    this.router.navigateByUrl('/offlineNewAddEdit');
    //  }
    //  else{
    //    localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    //    localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId); 
    //    this.router.navigateByUrl('/offlineRequestAddEdit');
    //  }


    //}
  }
  progressPopup(targetmodel) {
    this.NewSuccess.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }
  AddNewRequest() {

    localStorage.removeItem('offlineBookingId');
    localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    this.router.navigateByUrl('/offlineRequestAddEdit');
  }

   //20-jan-24
   OnRequestTypeChange = (typeId: number): void => {
    if (typeId == 2) {
      if (this.tktPnrRight.offlineIssue) {
        this.router.navigateByUrl('/offlineBookingRequestCreate');
      }
      else {
        document.getElementById("requestListError").innerHTML = "**You Do Not Have Right!";
        setTimeout(() => {
          document.getElementById("requestListError").innerHTML = "";
        }, 5000);
      }
    }
    else if (typeId == 3) {
      if (this.tktPnrRight.offlineIssue==false) {
        document.getElementById("requestListError").innerHTML = "**You Do Not Have Right!";
        setTimeout(() => {
          document.getElementById("requestListError").innerHTML = "";
        }, 5000);
      }
      else {

        localStorage.removeItem('offlineBookingId');
        localStorage.setItem('RequestActionOffline', 'User');
        localStorage.setItem('RequestTypeOffline', 'Create');
        localStorage.setItem('RequestTypeIdFromOffline', String(typeId));
        localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
        this.router.navigateByUrl('/offlineNewAddEdit');
      }
    }
    else if (typeId == 4) {
      if (this.tktPnrRight.offlineVoid==false) {
        document.getElementById("requestListError").innerHTML = "**You Do Not Have Right!";
        setTimeout(() => {
          document.getElementById("requestListError").innerHTML = "";
        }, 5000);
      }
      else {

        localStorage.removeItem('offlineBookingId');
        localStorage.setItem('RequestTypeIdFromOffline', String(typeId));
        localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
        this.router.navigateByUrl('/offlineRequestAddEdit');
      }
    }
    else if (typeId == 5) {
      if (this.tktPnrRight.offlinerefund==false) {
        document.getElementById("requestListError").innerHTML = "**You Do Not Have Right!";
        setTimeout(() => {
          document.getElementById("requestListError").innerHTML = "";
        }, 5000);
      }
      else {

        localStorage.removeItem('offlineBookingId');
        localStorage.setItem('RequestTypeIdFromOffline', String(typeId));
        localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
        this.router.navigateByUrl('/offlineRequestAddEdit');
      }
     }


    else if (typeId == 16) {
      if (this.tktPnrRight.offlineIssue == false) {
        document.getElementById("requestListError").innerHTML = "**You Do Not Have Right!";
        setTimeout(() => {
          document.getElementById("requestListError").innerHTML = "";
        }, 5000);
      }
      else {

        localStorage.removeItem('offlineBookingId');
        localStorage.setItem('RequestActionOffline', 'User');
        localStorage.setItem('RequestTypeOffline', 'Create');
        localStorage.setItem('OfflineArrived', 'true');
        localStorage.setItem('RequestTypeIdFromOffline', String(typeId));
        localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
        this.router.navigateByUrl('/offlineFlightSearch');
        //  this.router.navigateByUrl('/offlineNewAddEdit');
      }
    }
  }


//end


}
